import { useState } from "react";
import { Plus, Minus } from "lucide-react";
import { motion, AnimatePresence } from "framer-motion";

function Accordion({ title, content }) {
  const [isActive, setIsActive] = useState(false);

  const toggleAccordion = () => {
    setIsActive(!isActive);
  };

  return (
    <div className="w-full border-b border-[#004270]/20">
      {/* Botón de Encabezado */}
      <button
        type="button"
        onClick={toggleAccordion}
        className="flex w-full items-center justify-between py-2.5 px-4 text-left font-bold text-[#004270] transition-colors duration-300 hover:text-[#febe10] focus:outline-none text-sm md:text-base bg-[#fafafa]/50"
      >
        <span className="accordion-title">{title}</span>

        {/* Icono con transición de color y rotación opcional */}
        <div className="transition-transform duration-300">
          {isActive ? (
            <Minus className="h-4 w-4 md:h-5 md:w-5 text-[#febe10]" />
          ) : (
            <Plus className="h-4 w-4 md:h-5 md:w-5 text-[#004270]" />
          )}
        </div>
      </button>

      {/* Contenido Animado con Framer Motion */}
      <AnimatePresence initial={false}>
        {isActive && (
          <motion.div
            key="content"
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: "auto", opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            transition={{ duration: 0.3, ease: "easeInOut" }}
            className="overflow-hidden"
          >
            <div className="px-6 border border-[#004270]/20  text-sm leading-relaxed   [&_p]:text-[11pt]  ">
              {content}
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
}

export default Accordion;
